export default class APIUser {
  constructor(API) {
    this.api = API;
  }
  //Get tenant user object
  async getByID(userID) {
    const req = await this.api.newBaseRequest("GET");
    req.path = "/user/" + userID;
    return await req.exec();
  }
  //Create tenant user
  async create(userObj) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/user/" + userObj.id;
    req.body = { ...userObj };
    return await req.exec();
  }
  //Update tenant user
  async update(userObj) {
    const req = await this.api.newBaseRequest("PUT");
    req.path = "/user/" + userObj.id;
    req.body = { ...userObj };
    return await req.exec();
  }
  //Update tenant user ITA number
  async updateITA(userID, userObj) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/user/" + userID + "/updateITA";
    req.body = { ...userObj };
    return await req.exec();
  }

  //Search
  async searchUsersByTerm(term, filter, quantifier) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/tenant/search/users/term";
    req.body = { searchTerm: term, filter: filter ? filter : {} };
    if (quantifier) {
      req.body.quantifier = quantifier;
    }
    return await req.exec();
  }
  async printSearchUsersByTerm(term, filter) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/tenant/report/users/simple";
    req.bodyType = "JSON/BLOB";
    req.body = { searchTerm: term, filter: filter ? filter : {} };
    return await req.exec();
  }
  async searchUsersByIDs(ids) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/tenant/search/users/ids";
    req.body = { IDs: ids ? ids : [] };
    return await req.exec();
  }
  //Report
  async usersAdvancedReport(fromDate, toDate, columns, dateType) {
    const req = await this.api.newBaseRequest("POST");
    req.path = "/tenant/report/users/advanced";
    req.bodyType = "JSON/BLOB";
    req.body = { from: fromDate, to: toDate, columns, dateType };
    return await req.exec();
  }
  //Gets status of a requirement
  async getRequirementStatus(userID, sourceID) {
    const req = await this.api.newBaseRequest("GET");
    req.path = `/user/${userID}/requirement/${sourceID}`;
    return await req.exec();
  }

  async getStatusForMultipleRequirements(userID, requirements) {
    const req = await this.api.newBaseRequest("POST");
    req.path = `/user/${userID}/requirements`;
    req.body = { requirements };
    return await req.exec();
  }

  async refreshOrgMembership(userID) {
    const req = await this.api.newBaseRequest("POST");
    req.path = `/user/${userID}/refreshOrgMembership`;
    return await req.exec();
  }
}
